/* eslint-disable complexity */
import { Injectable } from '@angular/core';
import { AccountCookie } from '../models/login-dashboard.interfaces';

@Injectable({ providedIn: 'root' })
export class UtilsService {
  setCookies(cookieName: string, cookieValue: string, days = 7) {
    const cookiesLife = new Date();
    cookiesLife.setTime(cookiesLife.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = '; expires=' + cookiesLife.toUTCString();
    const cookieDomain = ';domain=.delta.com;path=/';
    const cookieDetails =
      cookieName + '=' + cookieValue + expires + cookieDomain;
    document.cookie = cookieDetails;
  }

  getCookies(cookieName: string) {
    const result = new RegExp(
      '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
    ).exec(document.cookie);
    return result ? result[1] : '';
  }

  getAccountCookieValue(): AccountCookie | null {
    try {
      const accountCookieString = this.getCookies('account');
      if (accountCookieString) {
        return JSON.parse(accountCookieString) as AccountCookie;
      } else {
        return null;
      }
    } catch {
      return null;
    }
  }

  deleteCookie(cookieName: string) {
    const date = new Date();
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    const cookieDomain = ';domain=.delta.com;path=/';
    document.cookie =
      cookieName + '=; expires=' + date.toUTCString() + cookieDomain;
  }
}
